import CockpitNotificationStateLookupModelBase from '../_generated/modelBases/cockpit-notification-state-lookup-model-base';

export default class CockpitNotificationStateLookupModel extends CockpitNotificationStateLookupModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
